export const getSubjectTableColumns = () => [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => text || `SUB${(index + 1).toString().padStart(3, '0')}`,
    },
    {
      title: "Subject Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text || "N/A",
    },
    {
      title: "Teacher",
      dataIndex: "teacher",
      key: "teacher",
      render: (text, record) => {
        if (text) return text;
        if (record.teacherName) return record.teacherName;
        if (record.instructor) return record.instructor;
        return "N/A";
      },
    },
    {
      title: "Credits",
      dataIndex: "credits",
      key: "credits",
      render: (text) => text || "0",
    },
  ];